import { render, staticRenderFns } from "./S3ImageUploader.vue?vue&type=template&id=6478bcbc&scoped=true"
import script from "./S3ImageUploader.vue?vue&type=script&lang=js"
export * from "./S3ImageUploader.vue?vue&type=script&lang=js"
import style0 from "./S3ImageUploader.vue?vue&type=style&index=0&id=6478bcbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6478bcbc",
  null
  
)

export default component.exports